module.exports = __webpack_public_path__ + "img/background_c2.ed87b35d.jpg";